import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["status"]
    static values = {
        accountId: String,
        statusUrl: String,
        settingsUrl: String
    }

    connect() {
        this.poll()
    }

    disconnect() {
        if (this.timer) clearInterval(this.timer)
    }

    poll() {
        this.check()
        this.timer = setInterval(() => this.check(), 3000)
    }

    async check() {
        if (!this.accountIdValue) return

        try {
            const url = `${this.statusUrlValue}?account_id=${encodeURIComponent(this.accountIdValue)}`
            const response = await fetch(url, { headers: { Accept: "application/json" } })
            const data = await response.json()
            if (data.connected) {
                this.statusTarget.textContent = "Connected! Redirecting…"
                clearInterval(this.timer)
                window.location.href = this.settingsUrlValue
            }
        } catch (_error) {
            this.statusTarget.textContent = "Still waiting for WhatsApp…"
        }
    }
}
